



























import { defineComponent, computed, ref } from '@vue/composition-api'

export default defineComponent({
  props: {
    type: {
      required: false,
      type: String,
      default: 'text',
    },
    name: {
      required: true,
      type: String,
    },
    id: {
      required: false,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    value: {
      type: String,
    },
    autocomplete: {
      required: false,
      type: String,
    },
    required: {
      required: false,
      type: Boolean,
      default: false,
    },
    novalidate: {
      required: false,
      type: Boolean,
      default: false,
    },
    light: {
      required: false,
      type: Boolean,
      default: false,
    },
    inputClasses: {
      type: String,
    },
  },
  setup(props, ctx) {
    const untouched = ref(true)

    const pristine = computed(() => untouched.value && !props.value)

    const reset = () => {
      ctx.emit('input', null)
      untouched.value = true
    }

    return {
      pristine,
      untouched,
      reset,
    }
  },
})
